//Standard libraries
import { AxiosPromise } from "axios";
//Foundation libraries
import { getSite } from "../../hooks/useSite";
import { site } from "../../constants/site";
import { DeleteAccountApi } from "@hcl-commerce-store-sdk/typescript-axios-transaction";

const deleteAccountApiInstance = new DeleteAccountApi(undefined, site.transactionContext);
const messageService = {
  deleteAccount(parameters: any): AxiosPromise<any> {
    const siteInfo = getSite();
    const { storeId = siteInfo?.storeID, body, ...options } = parameters;
    return deleteAccountApiInstance.deleteAccount(storeId, body, options);
  },
};

export default messageService;
